var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      staticClass: "go-list-item",
      class: {
        "swiper-slide":
          _vm.styleFor !== undefined &&
          _vm.styleFor ===
            _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString(),
        "go-list-item-edit-reference":
          _vm.styleFor !== undefined &&
          _vm.styleFor === _vm.REFERENCE_STYLE_FOR.EDIT_REFERENCE.toString(),
      },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.showDetail(_vm.formModel)
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "go-card-sub",
          class: {
            "go-card-new":
              _vm.dataModelForView.isNew !== undefined &&
              _vm.dataModelForView.isNew === true,
            active:
              _vm.styleFor !== undefined &&
              _vm.styleFor ===
                _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString() &&
              _vm.checkedReferenceIds !== undefined &&
              _vm.checkedReferenceIds.includes(_vm.dataModelForView.id),
            "card-sub-edit-reference":
              _vm.styleFor !== undefined &&
              _vm.styleFor ===
                _vm.REFERENCE_STYLE_FOR.EDIT_REFERENCE.toString(),
            "card-sub-briefing-reference":
              _vm.styleFor !== undefined &&
              _vm.styleFor ===
                _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString(),
            "card-sub-report-reference":
              _vm.styleFor !== undefined &&
              _vm.styleFor ===
                _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString(),
          },
        },
        [
          _c(
            "div",
            {
              class: _vm.getClassFor(),
              staticStyle: { display: "flex", width: "auto" },
              attrs: { id: "wrap-body-reference-element" },
            },
            [
              _c("div", { staticClass: "go-card-header" }, [
                _c("div", { staticClass: "go-card-info" }, [
                  _vm.dataModelForView.isNew !== undefined &&
                  _vm.dataModelForView.isNew === true
                    ? _c("div", { staticClass: "go-info-item go-num-doc" }, [
                        _vm._v("N"),
                      ])
                    : _c(
                        "div",
                        {
                          staticClass: "go-info-item go-num-doc",
                          staticStyle: {
                            width: "auto",
                            display: "flex",
                            "white-space": "nowrap",
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.dataModelForView.indexNumber) +
                              "\n          "
                          ),
                        ]
                      ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "go-card-body",
                  class: {
                    "max-width-216px":
                      _vm.styleFor !== undefined &&
                      _vm.styleFor ===
                        _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString(),
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "go-block-body",
                      class: {
                        "min-width-194px":
                          _vm.styleFor !== undefined &&
                          _vm.styleFor ===
                            _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString(),
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "go-card-title",
                          class: {
                            "card-title-edit-reference":
                              _vm.styleFor !== undefined &&
                              _vm.styleFor ===
                                _vm.REFERENCE_STYLE_FOR.EDIT_REFERENCE.toString(),
                            "card-title-report-reference":
                              _vm.styleFor !== undefined &&
                              _vm.styleFor ===
                                _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString(),
                          },
                          staticStyle: {
                            "margin-left": "5px",
                            "margin-top": "3px",
                          },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.handleClickToTitle(_vm.formModel)
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.dataModelForView.title ||
                                  _vm.dataModelForView.description
                              ) +
                              "\n          "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "go-block-footer" }, [
                    _c(
                      "div",
                      {
                        staticClass: "go-card-info",
                        class: {
                          "max-width-306px":
                            _vm.styleFor !== undefined &&
                            _vm.styleFor ===
                              _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString(),
                          "max-width-113px":
                            _vm.styleFor !== undefined &&
                            _vm.styleFor !==
                              _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString(),
                        },
                      },
                      [
                        _vm.dataModelForView.type ===
                        _vm.REFERENCE_TYPE.NOTE.toString()
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "go-info-item go-label go-label-reference-card",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("briefing.view-card.label.note")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm.dataModelForView.type ===
                            _vm.REFERENCE_TYPE.FILE.toString()
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "go-info-item go-label go-label-reference-card",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.$t("briefing.view-card.label.file")
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "go-info-item go-channel" },
                              [
                                _vm.dataModelForView.faviconImage !==
                                  undefined &&
                                _vm.dataModelForView.faviconImage.trim()
                                  .length > 0 &&
                                !_vm.getErrorElementId.includes(
                                  "favicon_" +
                                    _vm.styleFor +
                                    "_" +
                                    _vm.dataModelForView.id
                                )
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "go-channel-thumb",
                                        attrs: {
                                          id:
                                            "favicon_" +
                                            _vm.styleFor +
                                            "_" +
                                            _vm.dataModelForView.id,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            loading: "lazy",
                                            src: _vm.dataModelForView
                                              .faviconImage,
                                            alt: "",
                                          },
                                          on: {
                                            error: function ($event) {
                                              return _vm.hideElementByIdLocalComponent(
                                                "favicon_" +
                                                  _vm.styleFor +
                                                  "_" +
                                                  _vm.dataModelForView.id
                                              )
                                            },
                                          },
                                        }),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("span", { staticClass: "go-channel-name" }, [
                                  _vm._v(_vm._s(_vm.dataModelForView.channel)),
                                ]),
                              ]
                            ),
                        _vm._v(" "),
                        _vm.styleFor !== undefined &&
                        _vm.styleFor ===
                          _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString() &&
                        _vm.dataModelForView.published_at
                          ? _c(
                              "div",
                              {
                                staticClass: "go-info-item go-datetime",
                                staticStyle: {
                                  "padding-left": "15px !important",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.formatDate(
                                        _vm.dataModelForView.published_at
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _vm.styleFor !== undefined &&
                    (_vm.styleFor ===
                      _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString() ||
                      _vm.styleFor ===
                        _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString())
                      ? _c(
                          "div",
                          { staticClass: "go-btn-area" },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn go-btn-icon go-btn-doc-preview",
                                attrs: {
                                  id:
                                    "popover-preview-" +
                                    _vm.dataModelForView.id,
                                  type: "button",
                                  "data-toggle": "popover",
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "go-icon-18 go-icon-preview",
                                }),
                              ]
                            ),
                            _vm._v(" "),
                            _vm.dataModelForView.originUrl &&
                            _vm.dataModelForView.channel !== "File" &&
                            _vm.hasntTopic(_vm.dataModelForView.id) &&
                            _vm.styleFor !== undefined &&
                            _vm.styleFor !==
                              _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString()
                              ? _c(
                                  "button",
                                  {
                                    staticClass: "btn go-btn-icon",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.openOriginal(
                                          _vm.dataModelForView.originUrl
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass: "go-tooltip-area",
                                        attrs: {
                                          "data-toggle": "tooltip",
                                          "data-placement": "bottom",
                                          title: _vm.$t(
                                            "companyDetailCommon.referencePopoverText"
                                          ),
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "go-icon-18 go-icon-newwindow",
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "b-popover",
                              {
                                attrs: {
                                  "custom-class": "go-popover-preview-doc",
                                  target:
                                    "popover-preview-" +
                                    _vm.dataModelForView.id,
                                  triggers: "hover",
                                  placement: "top",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    _vm.dataModelForView.description
                                      ? {
                                          key: "title",
                                          fn: function () {
                                            return [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "go-preview-info",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "go-channel",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.getFullChanel(
                                                            _vm.dataModelForView
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.dataModelForView
                                                    .published_at
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "go-datetime",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                _vm
                                                                  .dataModelForView
                                                                  .published_at
                                                              )
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "go-preview-title",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.dataModelForView
                                                          .title
                                                      ) +
                                                      "\n                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        }
                                      : null,
                                  ],
                                  null,
                                  true
                                ),
                              },
                              [
                                _vm._v(" "),
                                _vm.dataModelForView.description
                                  ? [
                                      _c(
                                        "p",
                                        { staticClass: "go-preview-desc" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.dataModelForView.description
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  : [
                                      _c(
                                        "div",
                                        { staticClass: "go-preview-empy" },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "go-icon-32 go-icon-hidden",
                                          }),
                                          _vm._v(" "),
                                          _c("p", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.view-card.preview-empty.text1"
                                                )
                                              )
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("small", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "briefing.view-card.preview-empty.text2"
                                                )
                                              )
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ],
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.styleFor !== undefined &&
          _vm.styleFor !==
            _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString() &&
          _vm.dataModelForView.type !== _vm.REFERENCE_TYPE.NOTE.toString() &&
          _vm.dataModelForView.imageUriThumbnail !== undefined &&
          _vm.dataModelForView.imageUriThumbnail.trim().length > 0 &&
          !_vm.getErrorElementId.includes(
            "imageReferenceThumbnail_" +
              _vm.styleFor +
              "_" +
              _vm.dataModelForView.id
          )
            ? _c(
                "div",
                {
                  staticClass: "image-view-element",
                  class: {
                    "go-card-img":
                      _vm.dataModelForView.type !==
                        _vm.REFERENCE_TYPE.NOTE.toString() &&
                      _vm.dataModelForView.type !==
                        _vm.REFERENCE_TYPE.FILE.toString(),
                    "go-card-icon":
                      _vm.dataModelForView.type ===
                      _vm.REFERENCE_TYPE.FILE.toString(),
                    "image-view-element-report-reference":
                      _vm.styleFor !== undefined &&
                      _vm.styleFor ===
                        _vm.REFERENCE_STYLE_FOR.REPORT_REFERENCE.toString(),
                  },
                  attrs: {
                    id:
                      "imageReferenceThumbnail_" +
                      _vm.styleFor +
                      "_" +
                      _vm.dataModelForView.id,
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      loading: "lazy",
                      src: _vm.dataModelForView.imageUriThumbnail,
                      alt: "",
                    },
                    on: {
                      error: function ($event) {
                        return _vm.hideElementByIdLocalComponent(
                          "imageReferenceThumbnail_" +
                            _vm.styleFor +
                            "_" +
                            _vm.dataModelForView.id
                        )
                      },
                    },
                  }),
                ]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.styleFor !== undefined &&
      _vm.styleFor === _vm.REFERENCE_STYLE_FOR.BRIEFING_REFERENCE.toString()
        ? _c(
            "button",
            {
              staticClass: "btn go-btn-check",
              class: {
                active:
                  _vm.checkedReferenceIds !== undefined &&
                  _vm.checkedReferenceIds.includes(_vm.dataModelForView.id),
              },
              attrs: {
                type: "button",
                "data-toggle": "button",
                "aria-pressed": "false",
                disabled: _vm.isWaitingResponse,
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.handleClickCheckedReference(_vm.formModel)
                },
              },
            },
            [_c("i", { staticClass: "go-icon-18 go-icon-check" })]
          )
        : _vm.styleFor !== undefined &&
          _vm.styleFor === _vm.REFERENCE_STYLE_FOR.EDIT_REFERENCE.toString()
        ? _c(
            "button",
            {
              staticClass: "btn go-btn-close",
              attrs: {
                type: "button",
                disabled: _vm.isLoadingSaveBriefingResource,
              },
              on: {
                click: function ($event) {
                  return _vm.handleDeleteReference(_vm.indexItem)
                },
              },
            },
            [_c("i", { staticClass: "go-icon-18 go-icon-close" })]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }